import { render, staticRenderFns } from "./detail-backup.vue?vue&type=template&id=1b1b35e6&"
import script from "./detail-backup.vue?vue&type=script&lang=js&"
export * from "./detail-backup.vue?vue&type=script&lang=js&"
import style0 from "./detail-backup.vue?vue&type=style&index=0&id=1b1b35e6&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports